class headerMenuHandler extends HTMLElement {
  constructor() {
    super();
    this.menuholder = this.querySelector('.vertical-menu__items');
    this.button = this.querySelector('.vertical-menu__show-more');
    Shopify.designMode?setTimeout(this.resizeMenu.bind(this), 400):false;
    this.createEvents();
    var _this = this;
    if(!Shopify.designMode){
      document.addEventListener("DOMContentLoaded", (event) => {
        setTimeout(_this.resizeMenu.bind(_this), 200);
        setTimeout(_this.resizeMenu.bind(_this), 1000);
      });
      document.addEventListener('visibilitychange', function(){
        if(!document.hidden) {
          setTimeout(_this.resizeMenu.bind(_this), 200);
        }
      });
    }
  }
  resizeMenu(){
    // "Always show every menu item": never trim to the neighbouring section's
    // height, so no item ends up behind the "show all" button. This only skips
    // the trimming -- the menu still stretches to the bottom of the section(s)
    // it sits beside, so the column lines up without any item being dropped.
    const show_all = this.hasAttribute('data-show-all');
    if(show_all){
      this.querySelectorAll('.hidden-menu-item').forEach((item) => {item.classList.remove('hidden-menu-item')});
      this.button.classList.add('hide');
    }

    const main_content = document.getElementById('MainContent'),
          items_top_position = window.scrollY + this.menuholder.getBoundingClientRect().top;
    
    if(!main_content.children.length) return;
    
    this.querySelectorAll('.hidden-menu-item').forEach((item) => {item.classList.remove('hidden-menu-item')});

    // The side-by-side layout this stretching exists for is desktop-only:
    // component-vertical-menu.css gates every [data-menu-in-content] rule behind
    // min-width:1025px, while theme.liquid sets that attribute at every width.
    // Below the breakpoint the menu sits in normal flow above the content and
    // can never overlap the next section, so stretching it to the section bottom
    // and reserving the overlap afterwards only leaves a large blank gap.
    const side_by_side = window.matchMedia('(min-width: 1025px)').matches;

    if(side_by_side && (main_content.hasAttribute('data-menu-in-content') || main_content.classList.contains('menu-opened-by-default'))){
      const index = Number(main_content.getAttribute('data-menu-in-content')) - 1,
      		section_height = window.scrollY + main_content.children[index].getBoundingClientRect().bottom,
      		menu_top_position = (this.closest('.menu-opened-by-default') ? 0 : window.scrollY) + this.getBoundingClientRect().top;
      var height = section_height - menu_top_position;

      if(this.closest('.menu-opened-by-default')){
        height = Math.min(height, this.menuholder.offsetHeight + 20);
		height = height < -1 ? this.menuholder.offsetHeight + 20 : height;
      }
      // height:100% makes the box definite, so anything taller than the target
      // spills out past the panel's background instead of growing it. That is
      // fine when renderItems() is about to trim the list to fit, but with
      // "show all" nothing gets trimmed -- so leave the height auto there and
      // let min-height do the stretching on its own. Short list: the panel
      // still reaches the section bottom. Long list: it grows to hold every item.
      this.style.height = show_all ? '' : '100%';
      this.style.minHeight = height+'px';
      if(!show_all) this.renderItems(items_top_position,height);

      // The panel is positioned absolutely, so once it outgrows the section it
      // spans it simply paints over whatever comes next. Reserve the overlap as
      // space after that section so the following one starts clear of it.
      // Margin rather than padding, so the next section's own background is not
      // stretched; and on the spanned section rather than the next one, because
      // that element's border box is what `height` above is measured from --
      // padding it would feed straight back into the next run and grow the
      // panel again every time. Recomputed from scratch each run, never added to.
      const spanned = main_content.children[index];
      if(spanned){
        const overlap = Math.ceil(window.scrollY + this.getBoundingClientRect().bottom - section_height);
        spanned.style.marginBottom = overlap > 0 ? (overlap + 30) + 'px' : '';
      }
    }
    else{
      // Nothing to line up against, or too narrow for the side-by-side layout:
      // drop any stretch and any reserved space left by a previous run, so
      // resizing down from desktop does not strand inline styles on the page.
      this.style.height = '';
      this.style.minHeight = '';
      const prev_index = Number(main_content.getAttribute('data-menu-in-content')) - 1,
            prev_spanned = main_content.children[prev_index];
      if(prev_spanned) prev_spanned.style.marginBottom = '';
      if(!show_all) this.renderItems(items_top_position,620);
    }
    this.hasAttribute('hide-before-load') && this.removeAttribute('hide-before-load');
  }
  renderItems(items_top_position,height){
    var hide_item = true;
    var offsetmain = this.menuholder.children[0].offsetTop;
    for(var i=this.menuholder.children.length-1; i>=0; i--){
      var item = this.menuholder.children[i],
          y = item.offsetTop + offsetmain + item.offsetHeight;
      if(this.menuholder.children.length-1 == i && y <= height){
        this.button.classList.add('hide');
        return 'break';
      }
      else if(y > height){
        this.button.classList.contains('hide') && this.button.classList.remove('hide');
        item.classList.add('hidden-menu-item');
      }
      else{
        if(hide_item){
          hide_item = false;
          y > height-this.button.offsetHeight-15 && item.classList.add('hidden-menu-item');
        }
      }
    }
  }
  resizeMenuEvent(){
    //if(Shopify.designMode){

    setTimeout(this.resizeMenu.bind(this), 800);
  }
  createEvents(){
    window.addEventListener('resize', this.resizeMenuEvent.bind(this));
    this.button.addEventListener('click', this.clickHandler.bind(this));
    document.addEventListener('click', this.outsideClickHandler.bind(this));
  }
  outsideClickHandler(event){
    // Close the dropdown on any click outside it. Left alone while it is pinned
    // open by default (home page, data-menu-opened). Goes through the summary so
    // header-drawer's own close path runs and clears the body classes it set.
    const details = this.closest('details');
    if(!details || !details.open || details.hasAttribute('data-menu-opened') || details.contains(event.target)) return;
    details.querySelector('summary').click();
  }
  clickHandler(event){
    if(this.button.classList.contains('active')){
      this.classList.remove('menu-show-items');
      setTimeout(this.hideItems.bind(this), 0);         
    }
    else{
      this.classList.add('menu-opened');
      this.button.classList.add('active');
      setTimeout(this.showItems.bind(this), 0);
    }
  }
  showItems(){
    this.classList.add('menu-show-items');
  }
  hideItems(){
    this.classList.remove('menu-opened');
    this.button.classList.remove('active');
    window.dispatchEvent(new Event('forStickyHeader'));
  }
}
customElements.define('vertical-menu', headerMenuHandler);


class verticalMenutext extends HTMLElement {
  constructor() {
    super();
    this.closest('.vertical-menu--hover__type2')&&this.closest('.vertical-menu--hover__type2').addEventListener('mouseenter', this.mouseenter.bind(this));
    this.closest('.vertical-menu__button')&&this.closest('.vertical-menu__button').addEventListener('mouseenter', this.mouseenter2.bind(this));
  }
  mouseenter(){
    var parent_width = this.closest('.vertical-menu--hover__type2').clientWidth;
    var item_width = this.clientWidth;
    var left = this.getBoundingClientRect().left - this.closest('.vertical-menu--hover__type2').getBoundingClientRect().left;
    var r = 0;

    if(document.querySelector('[dir="rtl"]')){
      r = Number(this.closest('.submenu-container')?31:15) - left;
      if(r<0){
        this.style.setProperty('--left', r + "px");
      }
      else{
        this.style.setProperty('--left', 0 + "px");
      }
    }
    else{
      r = Math.round(parent_width - item_width - left - Number(this.closest('.submenu-container')?31:10));
      if(r>0){
        this.style.setProperty('--left', r + "px");
      }
      else{
        this.style.setProperty('--left', 0 + "px");
      }
    }
  }
  mouseenter2(){
    var parent_width = this.closest('.vertical-menu__button').clientWidth;
    var item_width = this.clientWidth;
    var left = this.getBoundingClientRect().left - this.closest('.vertical-menu__button').getBoundingClientRect().left;
    var r = 0;

    if(document.querySelector('[dir="rtl"]')){
      var r = Math.round(20 - left);
      if(r<0){
        this.style.setProperty('--left', r + "px");
      }
      else{
        this.style.setProperty('--left', 0 + "px");
      }
    }
    else{
      var r = Math.round(parent_width - item_width - left - 20);
      if(r>0){
        this.style.setProperty('--left', r + "px");
      }
      else{
        this.style.setProperty('--left', 0 + "px");
      }
    }
  }
}
customElements.define('vertical-menutext', verticalMenutext);